import { fromPromise } from 'xstate';

import {
  type AccessTokens,
  type AccountData,
  type CreateAccountActorInput,
  type CreateAccountOutput,
  type RefreshAccessTokensInput,
  type SignInInput,
  type SignInOutput,
} from '../azure-auth-machine.types';

// ─── External Actors ─────────────────────────────────────────────────────────

const initialize = fromPromise<unknown>(async () => {
  throw new Error('`initialize` actor is not provided.');
});

const handleRedirect = fromPromise<AccountData>(async () => {
  throw new Error('`handleRedirect` actor is not provided.');
});

const authenticate = fromPromise<AccountData>(async () => {
  throw new Error('`authenticate` actor is not provided.');
});

const signIn = fromPromise<SignInOutput, SignInInput>(async () => {
  throw new Error('`signIn` actor is not provided.');
});

const createAccount = fromPromise<CreateAccountOutput, CreateAccountActorInput>(async () => {
  throw new Error('`createAccount` actor is not provided.');
});

const refreshAccessTokens = fromPromise<AccessTokens, RefreshAccessTokensInput>(async () => {
  throw new Error('`refreshAccessTokens` actor is not provided.');
});

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  initialize,
  handleRedirect,
  authenticate,
  signIn,
  createAccount,
  refreshAccessTokens,
};
